import { APIClient } from '@frontend/api-utils';
import { MqttSetting } from '@frontend/setting/types';

export class MqttSettingClient extends APIClient {
    public static readonly endpoint = '/setting-api/v1';

    public static async fetchMqttSettings(): Promise<MqttSetting> {
        const response = await this.fetch(`${this.endpoint}/mqtt-settings`);
        return await this.handleResponse<MqttSetting>(response);
    }
}